import toast from "react-hot-toast";
import { firebaseClient, getToken } from "../firebaseClient";
import { getAccount, updateUser } from "utils/sessionHelper";





export const fetchContracts = async (session, type) => {
    const response = await fetch('/api/ghostwriting/get?type=' + type + '&idUser=' + getAccount(session)?.id, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            tokenUserId: session?.user?.uid,
            token: await getToken(session, "fetchStripeConnectAccount"),
        }),
    });
    const json = await response.json();
    // console.log(json);

    if (json?.contracts?.length) {

        let contracts = json?.contracts.filter(x => x.status != "terminated");

        contracts.forEach((contract) => {
            if (contract.status == "pending") contract.statusPriority = 5;
            else if (contract.status == "running") contract.statusPriority = 4;
            else if (contract.status == "paused") contract.statusPriority = 3;
            else if (contract.status == "terminated") contract.statusPriority = 1;
            else contract.statusPriority = 2;
        });

        contracts = contracts.sort((a, b) => b.statusPriority - a.statusPriority);
        // console.log('newContacts:', newContacts)

        return contracts;
    }

    return [];
}

export const approve = async (tweet) => {

    const db = firebaseClient.firestore();
    await db.collection("users").doc(tweet.idUser).collection("tweets").doc(tweet.id).update({statusGhost: "ready", dateApproved: new Date()});
    tweet.statusGhost = "ready";
    toast.success("Content approved");
}


export const reject = async (tweet) => {

    const db = firebaseClient.firestore();
    await db.collection("users").doc(tweet.idUser).collection("tweets").doc(tweet.id).update({statusGhost: "rejected", dateRejected: new Date()});
    tweet.statusGhost = "rejected";
    toast.success("Revision request sent" + (tweet.ghostwriterTwUserName ? " to @" + tweet.ghostwriterTwUserName : ""));
}